import React, { useState, useEffect } from 'react';
import InputString from '../UI/Control/InputString';
import SelectList from '../UI/Control/SelectList';
import MultiSelectList from '../UI/Control/MultiSelectList';
import ArrowLeft from '../../Images/Icons/ArrowLeftBorder.svg';
import ArrowRight from '../../Images/Icons/ArrowRightBorder.svg';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TabClasses from './TabsStyle.css';

const AdjudicationRead = (props) => {
    // Add to selected list.
    function hanldleLeftShift(ctrl_avl, ctrl_sel, sequence, index) {
        let avlList = document.getElementById(ctrl_avl);
        let selList = document.getElementById(ctrl_sel);
        let options = avlList.selectedOptions;
        if (options.length > 0) {
            Array.from(options).map((option) => {
                selList.appendChild(option);
            });
            Array.from(options).map((option) => {
                avlList.removeChild(option);
            });
        }
        else
            alert('Select form to assign.')

        let tabId = 'Tab-CR-tab-Read_' + sequence + '_' + index;
        HighlightTabHeader(selList, tabId);
    }

    //Add item(s) to available list.
    function handleRightShift(ctrl_avl, ctrl_sel, sequence, index) {
        let avlList = document.getElementById(ctrl_avl);
        let selList = document.getElementById(ctrl_sel);
        let options = selList.selectedOptions;
        if (options.length > 0) {
            Array.from(options).map((option) => {
                avlList.appendChild(option);
            });
            Array.from(options).map((option) => {
                selList.removeChild(option);
            });
        }
        else
            alert('Select form to revoke.')

        let tabId = 'Tab-CR-tab-Read_' + sequence + '_' + index;
        HighlightTabHeader(selList, tabId);
    }

    useEffect(() => {
        for (var index = 0; index < props.noOfAdj.length; index++) {
            if (props.noOfAdj[index].selectedReads.length > 0) {

                let avlList = document.getElementById("multiSelectAdj_" + props.sequence + (index + 1));
                let selList = document.getElementById("multiSelectAdjSel_" + props.sequence + (index + 1));

                for (var iCount = 0; iCount < props.noOfAdj[index].selectedReads.length; iCount++) {
                    for (var i = 0; i < avlList.options.length; i++) {
                        if (props.noOfAdj[index].selectedReads[iCount].FormID == avlList.options[i].value) {
                            avlList.options[i].selected = (props.noOfAdj[index].selectedReads[iCount].FormID = avlList.options[i].value);
                        }
                    }
                }

                let options = avlList.selectedOptions;
                if (options.length > 0) {
                    Array.from(options).map((option) => {
                        selList.appendChild(option);
                    });
                    Array.from(options).map((option) => {
                        avlList.removeChild(option);
                    });
                }
                let tabId = 'Tab-CR-tab-Read_' + props.sequence + '_' + index;
                HighlightTabHeader(selList, tabId);
            }
        }

    }, []);

    function HighlightTabHeader(selList, tabId) {
        if (selList.length > 0) {
            document.getElementById(tabId).style.color = 'green';
            document.getElementById(props.tabId).style.color = 'green';
        }
        else {
            document.getElementById(tabId).style.color = '';
            document.getElementById(props.tabId).style.color = '';
        }
    }

    return (
        <div>
            <Tabs defaultActiveKey="profile" id="Tab-CR" defaultActiveKey={"Read_" + props.sequence+"_"+"0"}>
            {
                    props.noOfAdj.map((item, index) =>
                        <Tab eventKey={"Read_" + props.sequence+"_"+index} title={"CR " + (index + 1)} style={{color:"green"}}>
                    <div key={index} className="row">
                        <input type="hidden" id={"hdnADJCRFID_" + index} value={item.StudyParadigmCRFID} />
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-5" style={{ width: "49%", paddingLeft: "25px", paddingRight: "25px" }}>
                                    <InputString id={"txtAdjSearch_" + props.sequence + (index + 1)} onChangeHandler={props.searchChangeHandlerAdjRead} placeholder="Search" style={{ marginTop: "1px", lineHeight: "1.8rem", fontSize: "18px" }}></InputString>
                                </div>
                                <div className="col-sm-2" style={{ width: "2%" }}>
                                </div>
                                <div className="col-sm-5" style={{ width: "49%", paddingLeft: "25px", paddingRight: "25px" }}>
                                    <InputString id={"txtAdjSearchSelected_" + props.sequence + (index + 1)} onChangeHandler={props.searchChangeHandlerAdjReadSelected} placeholder="Search" style={{ marginTop: "1px", lineHeight: "1.8rem", fontSize: "18px" }}></InputString>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-5" style={{ width: "49%", paddingLeft: "25px", paddingRight: "25px" }}>
                                            <MultiSelectList id={"multiSelectAdj_" + props.sequence + (index + 1)} dataSource={props.multiSelectDataSource} selectedData={item.selectedReads} isMultiSelect="true" size="18" style={{ marginTop: "1px", lineHeight: "1.8rem", fontSize: "18px", height: "55vh" }} disabled={props.isDisabled}></MultiSelectList>
                                </div>
                                <div className="col-sm-2 d-flex align-items-center justify-content-center" style={{ width: "2%" }}>
                                    <table style={{ border: "none", marginTop: "5px" }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {!props.isDisabled && <img src={ArrowRight} style={{ width: "55px", height: "55px", cursor: "pointer" }} alt=">>"
                                                                onClick={() => hanldleLeftShift("multiSelectAdj_" + props.sequence + (index + 1), "multiSelectAdjSel_" + props.sequence + (index + 1), props.sequence, index )} />}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                            {((props.action.toLowerCase() == 'view' && (props.DeploymentStage.toLowerCase() == 'dev' || props.DeploymentStage.toLowerCase() == 'predev')) || (!props.isDisabled && (props.action.toLowerCase() == 'msc' || props.action.toLowerCase() == 'add' || props.action.toLowerCase() == 'edit') && props.DeploymentStage.toLowerCase() == 'predev')) && <img src={ArrowLeft} style={{ width: "55px", height: "55px", cursor: "pointer" }} alt="<<"
                                                                onClick={() => handleRightShift("multiSelectAdj_" + props.sequence + (index + 1), "multiSelectAdjSel_" + props.sequence + (index + 1), props.sequence, index)} />}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-sm-5" style={{ width: "49%", paddingLeft: "25px", paddingRight: "25px" }}>
                                            <MultiSelectList id={"multiSelectAdjSel_" + props.sequence + (index + 1)} isMultiSelect="true" size="18" style={{ marginTop: "1px", lineHeight: "1.8rem", fontSize: "18px", height: "55vh" }} disabled={props.isDisabled}></MultiSelectList>
                                </div>
                            </div>
                        </div>
                            </div>
                            </Tab>
                )
                }
            </Tabs>
            </div>
    );
};

export default AdjudicationRead;
